import { useEffect } from "react";

export const useConfirmLeave = () => {
  useEffect(() => {
    const fn = (e: any) => {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", fn);
    return () => {
      window.removeEventListener("beforeunload", fn);
    };
  }, []);
};
